<template>
    <b-container fluid>
        <vue-toastr ref="toastr" />
        <div :class="{blur: loading}">
            <b-row>
                <b-col>
                    <h1 class="mb-4">Франчайзинг</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="7">
                    <b-card title="Описание">
                        <h6>Франшиза "Агент"</h6>
                        <p>Официальное название статуса Дистрибьютора в статусе “Агент”. Стоимость франшизы “Агент” - € 100. Франшиза “Агент” дает право получать доходы от прямых продаж банковских услуг (депозитов) и процент от продаж услуг от двух уровней собственной агентской организации.</p>
                        <p>Ежемесячное роялти (активация франшизы) составляет € 10.</p>
                        <hr>
                        <h6>Франшиза "Супервайзер"</h6>
                        <p>Официальное название статуса Дистрибьютора в статусе “Супервайзер”. Стоимость франшизы “Супервайзер” - € 1000. Франшиза “Супервайзер” дает право получать доходы от:</p>
                        <ol>
                            <li>прямых продаж банковских услуг (депозитов)</li>
                            <li>процент от вознаграждений по депозитам двух уровней собственной агентской организации</li>
                            <li>денежные вознаграждения и автобонус за создание большой агентской организации</li>
                        </ol>
                        <p>Ежемесячное роялти (активация франшизы) составляет € 10.</p>
                    </b-card>
                    <b-card title="Маркетинговый план">
                        <p>Более подробно со всеми возможностями франчайзи Вы можете ознакомиться в <a href="static/marketing.pdf" target="_blank">Маркетинговом плане</a>.</p>
                    </b-card>
                </b-col>
                <b-col cols="5">
                    <b-card title="Приобрести">
                        <b-form @submit.prevent="orderFranchise">
                            <b-form-group label="Франшиза" label-for="franchise-order-type">
                                <b-form-select v-model="selectedFranchise" :options="availableFranchises" />
                            </b-form-group>
                            <b-button type="submit" variant="primary" :disabled="!selectedFranchise">
                                <i class="fa fa-cart-plus"></i>&nbsp;&nbsp;Заказать
                            </b-button>
                        </b-form>
                    </b-card>
                    <b-card title="Заказы" v-if="hasFranchiseOrders">
                        <b-table stripped hover :items="franchiseOrders" :fields="franchiseOrdersFields">
                            <template slot="title" scope="row">
                                {{ row.item.title }}<br/>
                                Стоимость: {{ row.item.amount }}
                            </template>
                            <template slot="paid" scope="row">
                                <b-button v-if="!row.item.paid" size="sm" variant="primary" @click.stop="paymentOrderId = row.item.id" v-b-modal.paymentSystems>
                                    <i class="fa fa-check"></i> Оплатить
                                </b-button>
                                <template v-else>{{ row.item.paid }}</template>
                            </template>
                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
            <modal-payment :order-id="paymentOrderId" />
        </div>
        <div v-if="loading" class="loading-container">
            <data-loading></data-loading>
        </div>
    </b-container>
</template>

<script>
    import DataLoading from '@/containers/DataLoading.vue'
    import Toastr from 'vue-toastr'
    import Payment from '@/components/Payment.vue'

    export default {
        name: 'Franchising',
        components: {
            'data-loading': DataLoading,
            'vue-toastr': Toastr,
            'modal-payment': Payment
        },
        data () {
            return {
                loading: false,
                paymentOrderId: null,

                marketingURL: 'static/marketing.pdf',
                marketingPage: 0,

                selectedFranchise: null,
                franchiseOrders: [],

                franchiseOrdersFields: {
                    title: {
                        label: '',
                        // thClass: 'small',
                        tdClass: 'small'
                    },
                    date: {
                        label: 'Дата заказа',
                        // thClass: 'small',
                        tdClass: 'small'
                    },
                    paid: {
                        label: 'Покупка',
                        // thClass: 'small',
                        tdClass: 'small',
                        formatter: (value) => {
                            if (value) {
                                return value
                            }
                            return ''
                        }
                    }
                }
            }
        },
        computed: {
            availableFranchises () {
                let franchises = []

                franchises.push({ value: null, text: 'Выберите интересующую Вас франшизу', disabled: true })

                if (!this.$auth.user()['franchisee']) {
                    franchises.push({ value: 'agent', text: 'Франшиза "Агент"' })
                }

                franchises.push({ value: 'supervisor', text: 'Франшиза "Супервайзер"' })

                return franchises
            },
            hasFranchiseOrders () {
                return (this.franchiseOrders.length > 0)
            }
        },
        mounted () {
            this.loadFranchiseOrders()
        },
        methods: {
            loadFranchiseOrders () {
                this.loading = true
                this.axios.get('franchising/franchise/orders')
                    .then(response => {
                        this.franchiseOrders = response.data['orders']

                        if (response.data.hasOwnProperty('message') && response.data['message']) {
                            this.$refs['toastr'].i(response.data['message'])
                        }

                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                    .catch(() => {
                        this.$refs['toastr'].e('Произошла ошибка')
                    })
            },
            orderFranchise () {
                this.axios.post('franchising/franchise/order', {
                    franchise_type: this.selectedFranchise
                }).then(response => {
                    let order = response.data['order']

                    let isNewOrder = true
                    this.franchiseOrders.forEach(oldOrder => {
                        if (oldOrder.id === order.id) {
                            isNewOrder = false
                        }
                    })
                    if (isNewOrder) {
                        this.franchiseOrders.unshift(order)
                    }

                    if (response.data.hasOwnProperty('message') && response.data['message']) {
                        this.$refs['toastr'].i(response.data['message'])
                    }

                    this.payOrder(order.id)
                }).catch(error => {
                    let message = 'Возникла ошибка'

                    if (error.response) {
                        message = error.response.data['message']
                    } else if (error.request) {
                        message = 'Произошла ошибка обработки запроса'
                    } else {
                        message = 'Произошла ошибка при отправке запроса'
                    }

                    this.$refs['toastr'].e(message)
                })
            },
            payOrder (orderId) {
                let message = 'Нет доступных систем оплаты.'
                this.$refs['toastr'].e(message)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Franchising.vue?44cd70a2